import React, { useRef } from "react";

// Invisible anti-spam: a hidden honeypot field + submission-timing token.
// Real users never see or fill the honeypot; bots that auto-fill fields or
// submit instantly are silently dropped server-side. Zero friction.
export function useAntiSpam() {
  const mountedAt = useRef(Date.now());
  const hpRef = useRef("");

  const getPayload = () => ({ hp: hpRef.current, elapsed_ms: Date.now() - mountedAt.current });

  const honeypot = (
    <div
      aria-hidden="true"
      style={{ position: "absolute", left: "-9999px", top: "-9999px", width: 0, height: 0, overflow: "hidden" }}
    >
      <label>
        Lascia vuoto questo campo
        <input
          type="text"
          name="company_website"
          tabIndex={-1}
          autoComplete="off"
          defaultValue=""
          onChange={(e) => { hpRef.current = e.target.value; }}
        />
      </label>
    </div>
  );

  return { getPayload, honeypot };
}
